import { IResource } from "./model/IResource";
import { getAll } from "./Provider";


const RESOURCE = 'resources';

export const Resource = {
  getAll: (query?: string) => getAll<IResource>(`${RESOURCE}?${query || ''}`),
}